import React, { useEffect } from 'react';
import { Modal, Form, Input, Select, Button, Row, Col } from 'antd';
import { X, ChevronDown } from 'lucide-react';
import type { DepartmentStatus } from '../../types/department';
import styles from './DepartmentModal.module.css';

const { TextArea } = Input;

export interface DepartmentFormData {
  code: string;
  name: string;
  description?: string;
  headId?: string;
  status: DepartmentStatus;
}

export interface AddDepartmentModalProps {
  open: boolean;
  onClose: () => void;
  onSubmit: (data: DepartmentFormData) => Promise<void>;
}

export const AddDepartmentModal: React.FC<AddDepartmentModalProps> = ({
  open,
  onClose,
  onSubmit,
}) => {
  const [form] = Form.useForm();
  const [loading, setLoading] = React.useState(false);

  useEffect(() => {
    if (open) {
      form.resetFields();
    }
  }, [open, form]);

  const handleSubmit = async () => {
    try {
      const values = await form.validateFields();
      setLoading(true);
      await onSubmit(values);
      form.resetFields();
      onClose();
    } catch (error) {
      console.error('Validation failed:', error);
    } finally {
      setLoading(false);
    }
  };

  const handleCancel = () => {
    form.resetFields();
    onClose();
  };

  return (
    <Modal
      open={open}
      onCancel={handleCancel}
      footer={null}
      closeIcon={<X size={20} />}
      className={styles.modal}
      width={800}
      destroyOnHidden
    >
      <div className={styles.modalContent}>
        <h2 className={styles.modalTitle}>
          Thêm mới phòng ban
        </h2>

        <Form
          form={form}
          layout="vertical"
          onFinish={handleSubmit}
          className={styles.form}
        >
          <Row gutter={24}>
            <Col span={12}>
              <Form.Item
                name="code"
                label="Mã phòng ban *"
                rules={[
                  { required: true, message: 'Vui lòng nhập mã phòng ban' },
                ]}
              >
                <Input
                  placeholder="Nhập mã phòng ban"
                  size="large"
                  className={styles.input}
                />
              </Form.Item>
            </Col>

            <Col span={12}>
              <Form.Item
                name="name"
                label="Tên phòng ban *"
                rules={[
                  { required: true, message: 'Vui lòng nhập tên phòng ban' },
                ]}
              >
                <Input
                  placeholder="Nhập tên phòng ban"
                  size="large"
                  className={styles.input}
                />
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            {/* <Col span={12}>
              <Form.Item
                name="headId"
                label="Trưởng phòng ban"
              >
                <div className={styles.selectWithIcon}>
                  <User size={16} className={styles.userIcon} />
                  <Select
                    showSearch
                    placeholder="Tìm kiếm"
                    size="large"
                    className={styles.select}
                    suffixIcon={<ChevronDown size={16} className={styles.dropdownIcon} />}
                    allowClear
                    filterOption={(input, option) =>
                      (option?.label ?? '').toLowerCase().includes(input.toLowerCase())
                    }
                    options={availableHeads.map((head) => ({
                      value: head.id,
                      label: head.name,
                    }))}
                    notFoundContent={availableHeads.length === 0 ? 'Không có dữ liệu' : undefined}
                  />
                </div>
              </Form.Item>
            </Col> */}

            <Col span={12}>
              <Form.Item
                name="status"
                label="Trạng thái *"
                rules={[
                  { required: true, message: 'Vui lòng chọn trạng thái' },
                ]}
                initialValue="active"
              >
                <Select
                  placeholder="Chọn trạng thái"
                  size="large"
                  className={styles.select}
                  suffixIcon={<ChevronDown size={16} className={styles.dropdownIcon} />}
                >
                  <Select.Option value="active">Hoạt động</Select.Option>
                  <Select.Option value="inactive">Không hoạt động</Select.Option>
                </Select>
              </Form.Item>
            </Col>
          </Row>

          <Row gutter={24}>
            <Col span={24}>
              <Form.Item
                name="description"
                label="Mô tả"
              >
                <TextArea
                  placeholder="Nhập mô tả phòng ban"
                  rows={4}
                  className={styles.textArea}
                />
              </Form.Item>
            </Col>
          </Row>

          <div className={styles.modalFooter}>
            <Button
              size="large"
              onClick={handleCancel}
              className={styles.cancelButton}
            >
              Huỷ
            </Button>
            <Button
              type="primary"
              size="large"
              onClick={handleSubmit}
              loading={loading}
              className={styles.submitButton}
            >
              Thêm mới
            </Button>
          </div>
        </Form>
      </div>
    </Modal>
  );
};

